import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class BrandAndLogoDesign extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Brand And Logo Design"
					title={"brand and logo design"}
					image={require('./image-4.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                                		Brand and Logo Design
                            			</div>
                       			 </h2>
                    		</div>


					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							

								<p>A brand is more than just how your company looks. Your brand (and branding) is a unique combination of your purpose, your skills, your target market, and your voice. </p>

								<h4>At Moshi Moshi we take the time to discuss the purpose of your business before anything else. </h4>


								
        <ul class="with-icons">
              <li>Who are you targeting?</li>
              <li>What problem are you solving?

</li>
              <li>What’s your brand positioning?</li>
        </ul>
    <p>Once your brand is nutted out, brainstormed and solidified, our experienced designers (with over 30 years combined experience) will work with you to create a logo that will resonate with your target market. Stuck on a name for your business? We can help with this as well to ensure you’re found as easily as possible by both your audience and search engines. We find the balance between creativity and practicality to help set up your business for success.

</p>
<p>At the end of the day, your brand is the face of your business. Our aim is to create a brand so strong for you that your customers will associate your name with your service straight away.</p>

<img src={require('./Hollow-Bar.png')} style={{padding: 30}} height="375" width="350" alt="The Hollow Beach Bar" className="align-centre" align="centre" />

<a href="https://www.moshi.com.au/what-weve-done/van-masters"><img src={require('./Van-Masters.png')} style={{padding: 30}} height="375" width="350" alt="Van Master Repairs" className="align-centre" align="centre" /></a>

<img src={require('./veca.png')} style={{padding: 30}}  height="375" width="350" alt="Veca Electrical Services" className="align-centre" align="centre" />

<hr></hr>
<h2>Related Services</h2>

							<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a> 		
<a class="btn" href="https://www.moshi.com.au/whatwedo/graphic-design">Graphic Design</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/public-relations">Public Relations</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/email-newsletter-management">Email Newsletter Management</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>		

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr><br></br>
<h3>Are you thinking of creating a new business? Maybe your current logo isn’t ‘sparking joy’ for you. Come in and see our team today for a no obligation meeting. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default BrandAndLogoDesign;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/BrandAndLogoDesign.js